import React from 'react';
import ReactGA from 'react-ga4';

import CampaignMenu from './CampaignMenu.jsx';
import CampaignInfoPosting from './CampaignInfoPosting.jsx';
import EnvironmentPosting from './EnvironmentPosting.jsx';
import Regions from './Regions.jsx';
import PanelMap from './PanelMap.jsx';
import BackgroundImage from './BackgroundImage.jsx';
import PanelListClassic from './PanelListClassic.jsx';
import * as colors from '../../services/colors.js'
import moment from 'moment';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
require('moment-weekday-calc');


export default class CampaignPostingLayout extends React.Component {
    constructor(props) {
        super(props);
        this.bg = Math.floor(Math.random() * 3) + 1;
        this.startDatePosting = null;
        this.endDatePosting = null;
        this.state = {
            loading: false,
            postingPeriod: 0
        };

    }

    componentDidMount() {
        const orderLines = this.props.orderData.orderLines;
        //in case the user has not selected start and end date with the date pickers the period is selected from the first and last of the selected orderlines
        if (!(this.props.startDate && this.props.endDate)) {
            let postingStart, postingEnd;
            for (let i = 0; i < orderLines.length; i++) {
                if (this.props.urlOrderLineIds.indexOf(orderLines[i].id) !== -1) {
                    if (orderLines[i].type === 'posting') {
                        if (postingStart) {
                            if (moment(orderLines[i].periodStart) < moment(postingStart)) {
                                postingStart = orderLines[i].periodStart;
                            }
                        } else {
                            postingStart = orderLines[i].periodStart;
                        }

                        if (postingEnd) {
                            if (moment(orderLines[i].periodEnd) > moment(postingEnd)) {
                                postingEnd = orderLines[i].periodEnd;
                            }
                        } else {
                            postingEnd = orderLines[i].periodEnd;
                        }
                    }
                }
            }
            this.startDatePosting = postingStart;
            this.endDatePosting = postingEnd;
        } else {
            this.startDatePosting = startDate;
            this.endDatePosting = endDate;
        }

        ReactGA.event({
            category: 'User',
            action: 'Report',
            label: 'Classic'
        });

        this.setState({
            selectedCampaignPromise: '',
            selectedCampaignType: "posting",
            campaignName: this.props.urlOrderLineIds.length === 1 ? this.props.orderData.orderLines.filter(x => x.id === this.props.urlOrderLineIds[0])[0].name : '',
            periodManuallySelected: this.props.startDate && this.props.endDate,
            periodStartPosting: this.startDatePosting,
            periodEndPosting: this.endDatePosting
        });
    }

    handleSelectDataType(dataType) {
        this.setState({
            selectedDataType: dataType
        });
    }

    handleSelectPostingDate(postingDate) {
        if (this.props.orderLinesData.postingData && this.props.orderLinesData.postingData.length > 0) {
            let postingPeriod = 0;
            for (var i = 0; i < this.props.orderLinesData.postingData.length; i++) {
                if (this.props.orderLinesData.postingData[i].postingDate === postingDate) {
                    postingPeriod = i;
                    continue;
                }
            }
            this.setState({
                postingPeriod: postingPeriod
            });
        }
    }

    allowAddressExport(campaignType, slotSubstitutionRule, campaignStartDate) {
        if (campaignType === "play") {
            return true;
        }
        if (slotSubstitutionRule === "1") {
            return true;
        }
        let exportAllowedFrom = moment(campaignStartDate).addWorkdays(this.props.parameters.daysToStartAdressExport * -1);
        return moment() >= exportAllowedFrom;
    }


    render() {
        let selectedData, color1, color2, postingData, selectedSummaryData, selectedSummaryDataType, campaignDaysGraph, selectedDetailsData, showCampaignDays, postingPeriods;
        let packageType = "";
        let allowAddressExport = true;

        if (this.props.orderLinesData) {
            showCampaignDays = false;
            color1 = colors.postingPrimary;
            color2 = colors.postingSecondary;
            postingPeriods = this.props.orderLinesData.postingData.map((x) => { return x.postingDate; });
            selectedSummaryData = this.props.orderLinesData.postingData[this.state.postingPeriod];
            selectedDetailsData = this.props.orderLinesData.postingData[this.state.postingPeriod];
            selectedData = this.props.orderLinesData.postingData[this.state.postingPeriod];
            postingData = selectedData;
            allowAddressExport = this.allowAddressExport(this.state.selectedCampaignType, this.props.orderLinesData.postingData[this.state.postingPeriod].slotSubstitutionRule, this.props.orderLinesData.postingData[this.state.postingPeriod].startDate);
            packageType = postingData.packageType;
        }

        return (
            <div>
                <BackgroundImage
                    campaignType={this.state.selectedCampaignType}
                    packageType={packageType} />

                {this.props.orderLinesData && 
                    <div>
                        <div className="container campaign-menu-container">
                            <CampaignMenu
                                playData={this.props.orderLinesData.playData}
                                postingData={postingData}
                                selectedCampaignType={this.state.selectedCampaignType} />
                        </div>

                        <div className="container">                            
                            {this.state.selectedCampaignType === "posting" &&
                                <CampaignInfoPosting
                                    selectedData={selectedSummaryData}
                                    selectedDataType=''
                                    onSelectPostingDate={(postingDate) => this.handleSelectPostingDate(postingDate)}
                                    selectedCampaignType={this.state.selectedCampaignType}
                                    campaignInfo={this.props.orderLinesData.orderLineDataInformation}
                                    campaignName={this.state.campaignName}
                                    periodManuallySelected={this.state.periodManuallySelected}
                                    orderData={this.props.orderData}
                                    selectedDetailsData={selectedDetailsData}
                                    parameters={this.props.parameters}
                                    contactsLabel=''
                                    panels={selectedData.panels}
                                    postingPeriods={postingPeriods}
                                    allowAddressExport={allowAddressExport} />
                            }
                        </div>
                        {showCampaignDays &&
                            <div className="container">
                                {campaignDaysGraph}
                            </div>
                        }
                        <div className="container graphs">
                            <div className="row">
                                <div className="col-md-6">
                                    <Regions
                                        showTarget={false}
                                        color1={color1}
                                        color2={color2}
                                        regions={selectedData.regions}
                                        dataType="Postings"
                                        header="Postings"
                                        campaignType={this.state.selectedCampaignType} />

                                    <EnvironmentPosting
                                        color={color1}
                                        environment={selectedData.environments}
                                        dataType="Postings"
                                        campaignType={this.state.selectedCampaignType} />
                                </div>

                                <div className="col-md-6">
                                    <PanelMap
                                        color1={color1}
                                        color2={color2}
                                        panels={selectedData.panels}
                                        campaignType={this.state.selectedCampaignType}
                                        campaignName={selectedData.campaingName}
                                        header="Panel locations and status"
                                        parameters={this.props.parameters}
                                        allowAddressExport={allowAddressExport}
                                        packageType={packageType}
                                        showPanelExport={true}
                                        showPostingExportIDS={selectedData.postingIDSExport} />
                                </div>
                            </div>

                            {this.props.parameters.showPostingAddressList &&
                                <div className="row">
                                    <div className="col-md-12">
                                        <PanelListClassic
                                            panels={selectedData.panels}
                                            header="Address list" />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }
}
